import { motion } from "framer-motion";

const HERO_BG = "https://images.unsplash.com/photo-1567360425618-1594206637d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjByZWQlMjBkYXJrJTIwYWJzdHJhY3R8ZW58MHx8fHwxNzgzNDMwOTIwfDA&ixlib=rb-4.1.0&q=85";
const HERO_ACADEMIC = "https://static.prod-images.emergentagent.com/jobs/c7fbc697-e5e1-42c6-9a40-d0f9028d1ed5/images/ea78a402d57004df1c6bf3ac2682da7b17851fffb1524ab5abb7d1bf61ff41fe.png";
const PARTNER_LOGOS = "https://customer-assets.emergentagent.com/job_kairos-latam-hub/artifacts/4uzvrh7d_Copia%20de%20Disen%CC%83o%20sin%20ti%CC%81tulo%20%281%29.png";

export function Hero() {
  const scrollToForm = () => document.getElementById("registro")?.scrollIntoView({ behavior: "smooth" });
  const scrollToModel = () => document.getElementById("solution")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden bg-crimson">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-crimson via-crimson to-crimson-dark" />
        <img src={HERO_BG} alt="" className="w-full h-full object-cover opacity-20 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-t from-crimson-dark/60 via-transparent to-transparent" />
        <div className="absolute -top-40 -right-40 w-[36rem] h-[36rem] rounded-full bg-ivory/10 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-32 pb-20 w-full">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <span className="font-sans text-xs uppercase tracking-[0.25em] text-ivory font-bold">Franquicia Digital · Latinoamérica</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] text-ivory mt-6"
          >
            La franquicia sin el<br className="hidden sm:block" /> riesgo del{" "}
            <span className="italic underline decoration-ivory/40 underline-offset-8">ladrillo</span>.
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="font-sans text-lg sm:text-xl font-light leading-relaxed text-ivory/90 mt-8 max-w-2xl"
          >
            Opere un negocio educativo completo, 100% digital. Sin local, sin inventario,
            sin nómina en piso. Nosotros ponemos la plataforma, el CRM, la pauta y el soporte.
            Usted opera y captura el retorno.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.45 }}
            className="mt-11 flex flex-col sm:flex-row items-start sm:items-center gap-4"
          >
            <button
              data-testid="hero-primary-cta"
              onClick={scrollToForm}
              className="bg-ivory text-crimson font-bold py-4 px-9 hover:bg-white transition-all hover:scale-[1.02] uppercase tracking-wider text-sm w-full sm:w-auto"
            >
              Precalificar para la franquicia
            </button>
            <button
              data-testid="hero-secondary-cta"
              onClick={scrollToModel}
              className="bg-transparent text-ivory font-bold py-4 px-9 border border-ivory/40 hover:border-ivory hover:bg-ivory/10 transition-all uppercase tracking-wider text-sm w-full sm:w-auto"
            >
              Ver el modelo
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.7 }}
            className="mt-16 grid grid-cols-3 gap-6 max-w-xl border-t border-ivory/20 pt-8"
          >
            {[
              ["0", "Locales físicos"],
              ["100%", "Operación digital"],
              ["Territorios", "Limitados por país"],
            ].map(([num, label]) => (
              <div key={label}>
                <div className="font-serif text-3xl sm:text-4xl font-bold text-ivory">{num}</div>
                <div className="font-sans text-xs uppercase tracking-wider text-ivory/70 mt-2">{label}</div>
              </div>
            ))}
          </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="hidden lg:block"
          >
            <div className="relative">
              <img
                src={HERO_ACADEMIC}
                alt="Estudiante operando su negocio educativo digital"
                className="w-full h-[78vh] max-h-[760px] object-cover shadow-2xl shadow-crimson-dark/50"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-ivory/20" />
              <div className="absolute inset-0 bg-gradient-to-t from-crimson-dark/90 via-crimson-dark/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-10">
                <div className="w-12 h-px bg-ivory/60 mb-5" />
                <p className="font-serif text-2xl lg:text-3xl font-medium italic text-ivory leading-snug">
                  «El aula ya no es un lugar. Hoy el negocio educativo vive en una pantalla.»
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-14 lg:mt-20 pt-8 border-t border-ivory/20"
        >
          <p className="font-sans text-xs sm:text-sm uppercase tracking-[0.18em] text-ivory/70 font-medium">
            Grandes instituciones y marcas educativas de prestigio internacional en un mismo sistema:
          </p>
          <img
            src={PARTNER_LOGOS}
            alt="Instituciones y marcas educativas aliadas"
            className="mt-6 w-full max-w-3xl h-auto object-contain opacity-90"
          />
        </motion.div>
      </div>
    </section>
  );
}
